module.exports = __webpack_public_path__ + "img/h100.fececf50.jpg";